import { VITE_USE_MOCK, VITE_MOCK_API, VITE_CASE_DATA2_API } from 'Constants/appEnvConstants';

export function getCaseData2BaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_CASE_DATA2_API;
}
